import React, { useCallback, useEffect, useRef } from 'react';
import type { Snackbar } from '../../../State/Snackbar/SnackbarProvider';

import { IconClose } from '../Icon';
import { Action, Close, Content, Item } from './wrapper';

const TIMEOUT = 10000;

interface SnackbarItemProps {
  snackbar: Snackbar;
  removeSnackbar: (id: number) => void;
  transform: (height: number) => void;
  disableRemove?: boolean;
}

const SnackbarItem = ({
  snackbar,
  removeSnackbar,
  transform,
  disableRemove,
}: SnackbarItemProps) => {
  const onClick = useCallback(() => removeSnackbar(snackbar.id), []);
  const ref = useRef<HTMLDivElement | null>(null);

  useEffect(() => {
    if (!disableRemove) {
      setTimeout(() => {
        removeSnackbar(snackbar.id);
      }, TIMEOUT);

      setTimeout(() => {
        if (ref.current?.clientHeight) {
          transform(ref.current.clientHeight);
        }
      }, TIMEOUT - 300);

      setTimeout(() => {
        if (ref.current) {
          ref.current.style.opacity = '0';
          ref.current.style.transition = 'opacity 300ms ease';
        }
      }, TIMEOUT - 600);
    }
    return () => {
      removeSnackbar(snackbar.id);
    };
  }, []);

  return (
    <Item
      $isSuccess={snackbar.type === 'success'}
      $isDanger={snackbar.type === 'error'}
      $isWarning={snackbar.type === 'warning'}
      ref={ref}
    >
      <Content>{snackbar.reactNode}</Content>
      <Action>
        <Close onClick={onClick}>
          <IconClose />
        </Close>
      </Action>
    </Item>
  );
};

export default SnackbarItem;
